import ProfileContactForm from '../modules/forms/profile/contact';

import ProjectsFilterForm from '../modules/forms/profile/projects-filter';
import ProjectFilter from '../modules/components/profile/projects-filter';

import JobsFilterForm from '../modules/forms/profile/jobs-filter';
import JobFilter from '../modules/components/profile/jobs-filter';

export default function setProfileScripts () {
    if (!window.location.pathname.includes('/user/')) return;

    new ProfileContactForm('#contact-user-form');

    if (document.querySelector('#projects-filter-form')) {
        new ProjectsFilterForm('#projects-filter-form');

        ProjectFilter();
    }

    if (document.querySelector('#jobs-filter-form')) {
        new JobsFilterForm('#jobs-filter-form');

        JobFilter();
    }
}
